import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Wines from "./pages/Wines";
import WineriesList from "./pages/WineriesList";
import WineryProfile from "./pages/WineryProfile";
import Login from "./pages/Login";
import Register from "./pages/Register";
import WineryDashboard from "./pages/WineryDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminOps from "./pages/AdminOps";
import AdminFinanceBank from "./pages/AdminFinanceBank";
import AdminFinanceInvoices from "./pages/AdminFinanceInvoices";
import About from "./pages/About";
import Contact from "./pages/Contact";
import DealPage from "./pages/DealPage";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#0A0A0A", border: "1px solid #27272A", color: "#fff" } }} />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/wines" element={<Wines />} />
                        <Route path="/wineries" element={<WineriesList />} />
                        <Route path="/winery/:slug" element={<WineryProfile />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/dashboard" element={<WineryDashboard />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/admin/ops" element={<AdminOps />} />
                        <Route path="/admin/finance/bank" element={<AdminFinanceBank />} />
                        <Route path="/admin/finance/invoices" element={<AdminFinanceInvoices />} />
                        <Route path="/deal/:id" element={<DealPage />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
